import { createSaga } from './saga-helpers';

import * as Api from '../api/notifications-api';

const watchGetNotifications = createSaga({
    type: 'NOTIFICATIONS_FETCH',
    fn: Api.fetchNotifications,
    args: action => [action.payload],
    successPayload: ({ notifications, hasMore }, action) => ({
        notifications,
        limit: action.payload.limit,
        filters: action.payload.filters,
        teamUrl: action.payload.teamUrl,
        triggeredBy: action.payload.triggeredBy,
        unreadOnly: action.payload.unreadOnly,
        resetState: action.payload.resetState,
        hasMore
    })
});

const watchRemoveNotifications = createSaga({
    type: 'NOTIFICATIONS_REMOVE',
    fn: Api.removeNotifications,
    args: action => [action.payload.notificationIds],
    successPayload: (response, action) => ({
        notificationIds: action.payload.notificationIds
    })
});

const watchReadNotifications = createSaga({
    type: 'NOTIFICATIONS_READ',
    fn: Api.readNotifications,
    args: action => [action.payload.notificationIds],
    successPayload: (response, action) => ({
        notificationIds: action.payload.notificationIds
    })
});

const watchUnreadNotifications = createSaga({
    type: 'NOTIFICATIONS_UNREAD',
    fn: Api.unreadNotifications,
    args: action => [action.payload.notificationIds],
    successPayload: (response, action) => ({
        notificationIds: action.payload.notificationIds
    })
});

const watchReadAllNotifications = createSaga({
    type: 'NOTIFICATIONS_READ_ALL',
    fn: Api.readAllNotifications
});

const sagas = [watchGetNotifications, watchRemoveNotifications, watchReadNotifications, watchUnreadNotifications, watchReadAllNotifications];

export default sagas;
